import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/style/universal.color';
import AccordionItemPattern from '@mlb/react-patterns/components/AccordionItem/AccordionItem';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import { SubHeading, HeadLine } from '@mlb/react-patterns/components/AccordionItem/AccordionItem.style';

export const Container = styled.div`
    width: 100%;
    color: ${COLORS.mlbWhite};
    border-bottom: 1px solid ${COLORS.mlbGrey6};

    &&& {
        button {
            :focus {
                outline: 2px solid ${COLORS.tabFocusColor};
            }
        }
    }
`;

export const AccordionItem = styled(AccordionItemPattern)`
    ${media.lgmin`
        padding: 0px 20px 0px 32px;
        ${SubHeading} {
            padding-right: 0px;
        }
        ${HeadLine} {
            padding-left: 0px;
        }
    `}
`;

export const Content = styled.div`
    padding: 20px 16px 10px;
    ${media.lgmin`
        padding: 20px 20px 10px 32px;
    `}
`;
